module.exports = __webpack_public_path__ + "static/hero-dcaf557e72652ca99b77167111e8c638.png";